export const getTotalCount = (store) => {
	return store.SpacesListing?.loadSpaces?.data?.meta?.totalCount;
};
